export const ProductTypes = [ "VT-Produkt", "Managed Service" ];
